import React from "react";
import { Link } from "react-router-dom";

const STUDIO_IMG = "https://images.pexels.com/photos/16307279/pexels-photo-16307279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const SKILLS = ["PAO", "Photoshop", "InDesign", "Mise en page", "Print", "Préparation imprimeur", "Création graphique"];

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="cs-cream border-b border-black/10 py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="cs-eyebrow text-neutral-500">À propos</div>
            <h1 className="cs-h1 mt-4 text-5xl lg:text-7xl">Un studio<br />indépendant.</h1>
            <p className="mt-8 cs-body text-neutral-700 max-w-xl">
              Charbonier Studio est un atelier graphique indépendant, spécialisé en préparation prépresse,
              mise en page éditoriale et création print. Le studio travaille pour des auteurs, éditeurs,
              associations, artisans et entreprises qui veulent des fichiers propres, envoyés au bon imprimeur, aux bonnes dimensions.
            </p>
            <p className="mt-6 cs-body text-neutral-700 max-w-xl">
              Pas de plateforme anonyme ni d'intermédiaire. Vous échangez directement avec le professionnel
              qui réalise votre projet : un interlocuteur unique, une exécution technique précise et un suivi
              constant du rendu final, jusqu'au fichier prêt pour l'impression.
            </p>
          </div>
          <div className="lg:col-span-5">
            <img src={STUDIO_IMG} alt="Studio" className="w-full aspect-[4/5] object-cover border border-black/15" />
          </div>
        </div>
      </section>

      <section className="cs-dark cs-grain py-20 border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="cs-eyebrow text-neutral-400">Compétences</div>
          <h2 className="cs-h2 mt-3 text-4xl lg:text-5xl text-[#FAF8F5]">Ce que fait Charbonier Studio.</h2>
          <div className="mt-10 flex flex-wrap gap-3">
            {SKILLS.map((s) => (
              <span key={s} className="px-4 py-2 border border-white/25 text-sm font-mono">{s}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="cs-cream py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
          <h3 className="cs-h2 text-4xl lg:text-5xl">Un projet à préparer&nbsp;?</h3>
          <p className="mt-4 text-neutral-700 max-w-xl mx-auto">Décrivez votre besoin — nous revenons vers vous rapidement.</p>
          <div className="mt-8 flex gap-4 justify-center flex-wrap">
            <Link to="/services" className="cs-btn-primary">Voir les prestations</Link>
            <Link to="/demande-devis" className="cs-btn-ghost !text-black !border-black">Demander un devis</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
